import React from "react";

function NoResults() {
  return (
    <div
      className="d-flex justify-content-center"
      style={{ height: "100vh", marginTop: "20px" }}
    >
      <div className="inline-block align-middle">
        <h2 className="font-weight-normal lead" id="desc">
          No Results found for your request
        </h2>
      </div>
    </div>
  );
}

export default NoResults;
